<!--
 * @Author: guoyun 327227584@qq.com
 * @Date: 2023-11-14 20:11:59
 * @LastEditors: guoyun 327227584@qq.com
 * @LastEditTime: 2023-11-30 09:32:28
-->
<template>
  <div class="overlay-tdt" ref="overlayTdt">
    <slot />
  </div>
</template>

<script>
import OverlayTd from './OverlayTd'
export default {
  props:{
    viewer:{
      type:Object,
      default(){
        return null
      }
    },
    position:{
      type:Object,
      default(){
        return null
      }
    },
    offset:{
      type:Array,
      default(){
        return [0,0]
      }
    }
  },
  data(){
    return{
      overlay_:null
    }
  },
  mounted(){
    this.init()
  },
  watch:{
    viewer(){
      this.init()
    },
    position(){
      this.setPosition(this.position)
    },
  },
  methods:{
    init(){
      if(this.viewer){
        this.setMap(this.viewer)
      }
      
    },
    setMap(viewer){
      if (!viewer) {
        return
      }
      this.viewer_ = viewer
      this.overlay_ = new OverlayTd({
        viewer,
        element:this.$refs.overlayTdt,
        offset:this.offset
      })
    },
    setPosition(position){
      if (!this.overlay_) {
        return
      }
      
      if (position && (position._value||position.x)) {
        this.overlay_.setPosition(position)
      }else{
        this.overlay_.setPosition(null)
      }
    }
  }
}
</script>

<style>

</style>
